<template>
    <div class="app-container">
        <el-card shadow="hover">
            <!-- 查询和其他操作 -->
            <div class="filter-container">
                <el-form ref="queryForm" :inline="true" :model="query" class="top-search" size="small">
                    <!-- <el-form-item prop="name">
                    <el-input v-model="query.name" placeholder="请输入客户名称" clearable style="width:160px" />
                </el-form-item> -->
                    <el-form-item prop="mobile">
                        <el-input v-model="query.mobile" placeholder="请输入客户电话" clearable style="width:160px" />
                    </el-form-item>
                    <el-form-item label=" ">
                        <el-button type="primary" @click="onSearch">查询</el-button>
                        <el-button class="btn-reset" @click="resetForm()">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <div class="total-text" style="float: left;">
                <div>
                    共 <span class="theme-text-color">{{ totalCount }}</span> 个客户
                </div>
                <div>
                    去重后 <span class="theme-text-color">{{ ignoreDuplicateCount }}</span> 个客户
                    <el-popover placement="top-start" trigger="hover" popper-class="tip-popover">
                        <div>
                            若客户添加多个员工，不重复计数
                        </div>
                        <i slot="reference" class="iconfont icon-question" style="font-size: 14px;" />
                    </el-popover>
                </div>
            </div>

            <div style="float: right;margin-bottom: 10px;">
                <el-button @click="sync">同步客户</el-button>
                <el-button @click="makeTag('add')">批量打标签</el-button>
                <!-- <el-button @click="makeTag('remove')">批量移除标签</el-button> -->
            </div>

            <el-table ref="table" v-loading="loading" :data="list" tooltip-effect="dark" highlight-current-row>
                <template slot="empty">
                    <empty-default-icon text="暂无数据" desc="若首次加载，请耐心等待后台数据同步，稍后回来"
                        :desc-show-condition="{ name: query.name, userIds: query.userIds, tagIds: query.tagIds, beginTime: query.beginTime, endTime: query.endTime }"
                        :desc-config="['customSecret']" />
                </template>
                <!-- <el-table-column key="row-1" type="selection" align="center" width="55" /> -->
                <el-table-column key="row-2" label="客户" prop="name" align="left" fixed min-width="280">
                    <template slot-scope="{ row }">
                        <div class="customer-info cp" @click="goRoute(row)">
                            <img :src="row.avatar">
                            <div class="customer-name">
                                <div class="inoneline" :title="(row.remark || row.name || row.alias)">
                                    <span>{{ row.remark || row.name || row.alias }}</span>
                                    <span
                                        :class="row.type === wxType ? 'wx-type-flag' : 'corp-type-name'">{{ row.type == "1" ? '@微信' : '' }}</span>
                                </div>
                                <div class="customer-real-name inoneline" :title="row.name">{{ row.name }}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>

                <el-table-column v-for="(colunmItem, columnIndex) in columnList"
                    :key="`${columnIndex}-${colunmItem.id}`" :label="colunmItem.name" prop="name" align="left"
                    min-width="180">
                    <template slot-scope="{ row }">
                        <div v-if="colunmItem.id === 'remarkMobiles'">
                            {{ row.remarkMobiles || row.cusMobile }}
                        </div>
                        <div v-else-if="colunmItem.id === 'remark'">
                            {{ row.remark || '' }}
                        </div>
                        <div v-else-if="colunmItem.id === 'createTime'">
                            {{ row.createTime || '' }}
                        </div>
                        <div v-else-if="colunmItem.id === 'userName'">
                            <div class="al">
                                <div class="cus-owner">{{ row.userName || '' }}</div>
                                <div class="cus-dept">{{ row.department || '' }}</div>
                            </div>
                        </div>
                        <div v-else-if="colunmItem.id === 'tag'">
                            <el-tag v-for="(unit, unique) in row.workerTags" :key="unique" type="info">{{
                                unit.name
                            }}
                            </el-tag>
                        </div>
                        <!-- <div v-else-if="colunmItem.id === 'status'">
                            {{ CUSTOMER_STATUS[row.status] || '' }}
                        </div> -->
                        <div v-else-if="colunmItem.id === 'workerNo'">
                            <el-tag :type="row.workerNo ? 'success' : ''">{{
                                row.workerNo ? '已认证' : '未认证'
                            }}</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column key="row-3" label="操作" width="80" fixed="right">
                    <template #header>
                        <div class="customer-status">
                            <span>操作</span>
                        </div>
                    </template>
                    <template slot-scope="{ row }">
                        <el-button type="text" size="small" @click="goRoute(row)">详情</el-button>
                    </template>
                </el-table-column> -->
            </el-table>
            <pagination v-show="total > 0" :total="total" :page.sync="query.pageIndex" :limit.sync="query.pageSize"
                :select-data-len="multipleSelection.length" @pagination="getList()" />

        </el-card>
    </div>

</template>

<script>
import service from "@/script/api/workercrmapi";
import Pagination from "@/components/common/Pagination";

export default {
    name: 'Customer',
    components: { Pagination },
    props: {},
    data() {
        return {
            query: {
                pageIndex: 1,
                pageSize: 50,
                mobile: '', // "客户手机" 
            },
            loading: true,
            total: 0,
            // 添加标签表单
            form: {
                groupName: '',
                weTags: [],
            },
            list: [], // 客户列表
            multipleSelection: [], // 多选数组 s
            // 去重后的客户总数
            ignoreDuplicateCount: 0,
            // 客户总数
            totalCount: 0,
            columnList: [
                { id: "tag", name: '标签' },
                { id: "workerNo", name: '是否认证' },
                { id: "userName", name: '所属员工' },
                { id: 'remarkMobiles', name: '备注手机' },
                { id: 'remark', name: '备注' },
                { id: 'createTime', name: '添加时间' },]
        };
    },
    computed: {
    },
    watch: {
    },
    created() {
        this.getList();
    },
    methods: {
        deleteTag(tag) {
            const index = this.queryTag.findIndex((tag_) => tag_.tagId === tag.tagId);
            this.queryTag.splice(index, 1);
            this.query.tagIds = this.queryTag.map((tag) => tag.tagId) + '';
        },
        getList(page) {
            this.loading = true;
            console.info(this.query)
            service
                .$axiosCpWorkerList(this.query)
                .then((res) => {
                    this.list = res.data.data.list.list;
                    this.total = +res.data.data.list.total;
                    this.totalCount = res.data.data.count.total;
                    this.ignoreDuplicateCount = res.data.data.count.duplicate;
                    this.loading = false;
                    console.info(this.list)
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        makeTag(type) {
            service.$axiosCpMarkTagAsync().then(res => {
                this.$notify.success({
                    title: "成功",
                    message: "后台开始批量打标签，请稍后关注进度",
                });
            })
            return;
            if (!this.multipleSelection.length) {
                let msg = '请选择一位客户';
                if (type === 'add') msg = '请至少选择一位客户';
                this.msgWarn(msg);
                return;
            }
            this.selectedTags = [];
            const hasErrorTag = [];
            const repeat = [];
            this.multipleSelection.forEach((element) => {
                element.weFlowerCustomerTagRels.forEach((grandchild) => {
                    // 判断是否有重复标签
                    const isRepeat = this.selectedTags.some((tag) => {
                        return tag.tagId === grandchild.tagId;
                    });
                    // 去重
                    if (isRepeat) {
                        repeat.push(grandchild.tagName);
                        return;
                    }

                    const filter = this.listTagOneArray.find((tag) => {
                        return tag.tagId === grandchild.tagId;
                    });
                    // 如果没有匹配到，则说明该便签处于异常状态，可能已被删除或破坏
                    if (!filter) {
                        hasErrorTag.push(grandchild.tagName);
                        // isError = true
                        return;
                    }

                    type !== 'add' && this.selectedTags.push(filter);
                });
            });
            if (hasErrorTag.length > 0) {
                this.msgError('已有标签[' + hasErrorTag + ']不在标签库中，或存在异常');
                return;
            }
            if (type === 'remove' && this.selectedTags.length === 0) {
                this.msgError('该客户没有标签，不可进行移除');
                return;
            }
            if (type === 'remove') {
                this.removeTags = [...this.selectedTags];
                this.selectedTags = [];
            }

            this.tagDialogType = {
                title: type === 'add' ? '批量打标签' : '批量移除标签',
                infoMsg:
                    type === 'add'
                        ? '请选择要为已勾选客户打上的标签'
                        : '以下选中的标签，将从已勾选客户下移除',
                type: type,
            };
            this.dialogVisible = true;
            // this.$refs.selectTag.$forceUpdate()
        },
        sync() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            });
            service
                .$axiosCpWorkerAsync()
                .then(() => {
                    loading.close();
                    this.$notify.success({
                        title: "成功",
                        message: "后台开始同步数据，请稍后关注进度",
                    });
                })
                .catch((fail) => {
                    loading.close();
                    console.log(fail);
                });
        },
        resetForm(formName) {
            this.$refs['queryForm'].resetFields();
            this.query.tagIds = '';
            this.getList(1);
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.multipleSelection = selection;
        },
        // 用于多选变单选
        handleSelection(selection, row) {
            this.$nextTick(() => {
                this.$refs.table.clearSelection();
                this.$refs.table.toggleRowSelection(row, true);
            });
        },
        goRoute(row) {
            goRouteWithQuery(this.$router, 'customerDetail', this.query, {
                id: row.externalUserid,
                userId: row.userId,
                dimissionTime: row.dimissionTime,
                prePageType: 'customer',
            });
        },
        /**
         * 点击查询
         */
        onSearch() {
            this.getList(1);
        },
    },
};
</script>

<style lang="scss" scoped>
.iconfont {
    font-size: 16px;
    margin-left: 4px;
    color: #707070;

    &.icon-boy {
        color: #1296db;
    }

    &.icon-girl {
        color: #d62f81;
    }
}

.bfc-d+.bfc-d .el-checkbox:first-child {
    margin-left: 10px;
}

.cp {
    display: flex;
    align-items: center;
    justify-content: center;
}

.cus-owner {
    font-size: 14px;
    color: #333;
}

.cus-dept {
    font-size: 12px;
    color: #666;
}

.el-tag {
    height: 18px;
    line-height: 12px;
    font-size: 12px;
    padding: 3px;
    border-radius: 3px;
    margin-bottom: 2px;
}

.total-text {
    div {
        line-height: 18px;

        span {
            font-weight: bold;
        }
    }
}

.customer-status {
    display: flex;
    align-items: center;

    .property-setting {
        margin-left: 10px;
    }
}

.file-preview-list {
    div {
        color: #377aff;
        cursor: pointer;
    }
}

.el-table .cell {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    line-height: 21px;
    padding-left: 10px;
    padding-right: 10px;
}

.customer-info {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: left;
    -ms-flex-pack: left;
    justify-content: left;
    height: 42px;
}

.customer-info .customer-name {
    width: calc(100% - 40px);
    height: 100%;
    font-size: 14px;
    color: #333;
    text-align: left;
}

.customer-info img {
    width: 35px;
    height: 35px;
    border-radius: 3px;
    margin-right: 5px;
}

.corp-type-name {
    color: #38af70;
}

.cp {
    cursor: pointer;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

.el-table .el-table__cell {
    padding: 12px 0;
    min-width: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    text-overflow: ellipsis;
    vertical-align: middle;
    position: relative;
    text-align: left;
}
.el-tag {
    height: 18px;
    line-height: 12px;
    font-size: 12px;
    padding: 3px;
    border-radius: 3px;
    margin-bottom: 2px;
}
.el-tag:first-of-type {
    margin-right: 10px;
}
.el-tag+.el-tag {
    margin-right: 10px;
}

.el-tag.el-tag--info {
    background-color: #fff1e8;
    border-color: #fee3d0;
    color: #fa7216;
}
</style>
